import { Instance } from 'mobx-state-tree';
import { RoutesDispatchedDtoModelBase } from './RoutesDispatchedDtoModel.base';

/* The TypeScript type of an instance of RoutesDispatchedDtoModel */
export interface RoutesDispatchedDtoModelType extends Instance<typeof RoutesDispatchedDtoModel.Type> {}

/* A graphql query fragment builders for RoutesDispatchedDtoModel */
export { selectFromRoutesDispatchedDto, routesDispatchedDtoModelPrimitives, RoutesDispatchedDtoModelSelector } from './RoutesDispatchedDtoModel.base';

/**
 * RoutesDispatchedDtoModel
 */
export const RoutesDispatchedDtoModel = RoutesDispatchedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
